(function Module() {
	'use strict';

	var Chart = require('chart.js');

	mySynch.controller('FertilityDashboardController', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'ViewAuthorizationFactory',
		'clientLoggerService',
		function FertilityDashboardController($s, MSF, api,viewAuth, log) {
			var self = this;
			self.loading = true;

			self.showCohortDetail = function showCohortDetail(cohort) {
				if (!cohort.clickable) {
					return false;
				}

				MSF.loadPage('CohortDetail', {cohort: cohort, rha: self.rhaBoxItems});
			};

			var chart;
			var cohorts;

			self.dataUpdatedDate = null;

			self.rhaBoxItems = {
				IR: formattedRate(0),
				II: formattedDays(0),
				CR: formattedRate(0),
				PR: formattedRate(0),
				IRtop5: formattedRate(0),
				IItop5: formattedDays(0),
				CRtop5: formattedRate(0),
				PRtop5: formattedRate(0)
			};

			$s.pageViewBetaReq = ["CohortDash_Old"];


			$s.checkPermissions = function checkPermissions(){
				if(!viewAuth.farmIsInBeta($s.pageViewBetaReq)){   
					 var homePageStateName =  MSF.getUserHomepageStateName();
					 MSF.loadPage(homePageStateName);
				}

			}

			function formattedRate(rate) {
				return _.isNumber(rate) ? _.round(rate * 100, 1) + '%' : rate;
			}

			function formattedDays(days) {
				return _.isNumber(days) ? _.round(days, 1) + ' days' : days;
			}

			function formattedDecimal(val) {
				return (!_.isNumber(val) || _.isNaN(val)) ? val : _.round(val, 1);
			}

			function updateRhaBoxItems(rhaValues) {
				var ir = _.get(rhaValues, 'inseminationRate', 0);
				var ii = _.get(rhaValues, 'inseminationInterval', 0);
				var cr = _.get(rhaValues, 'conceptionRate', 0);
				var pr = _.get(rhaValues, 'pregnancyRate', 0);
				var irtop5 = _.get(rhaValues, 'inseminationRateTop5', 0);
				var iitop5 = _.get(rhaValues, 'inseminationIntervalTop5', 0);
				var crtop5 = _.get(rhaValues, 'conceptionRateTop5', 0);
				var prtop5 = _.get(rhaValues, 'pregnancyRateTop5', 0);

				self.rhaBoxItems = {
					IR: formattedRate(ir),
					II: formattedDays(ii),
					CR: formattedRate(cr),
					PR: formattedRate(pr),
					IRtop5: formattedRate(irtop5),
					IItop5: formattedDays(iitop5),
					CRtop5: formattedRate(crtop5),
					PRtop5: formattedRate(prtop5)
				};
			}

			function updateChart() {
				if (chart) {
					chart.destroy();
				}

				var jqChartElement = $('#fertility-cohort-trend-chart')[0];

				var cohortsWithinTimeFrame = _.filter(cohorts, function cohortsWithinTimeFrame(cohort) {
					var start = moment(cohort.startDate).startOf('day');
					var timeFrameStartPoint = moment(self.dataUpdatedDate, MSF.i18n.format.dateLong).subtract(self.chartState.timeFrame, 'months').startOf('day');
					var end = moment(cohort.endDate).startOf('day');
					var timeFrameEndPoint = moment().startOf('day');

					return start.isAfter(timeFrameStartPoint) && end.isBefore(timeFrameEndPoint);
				}).reverse();

				function getDaysInMilk(i) {
					return cohortsWithinTimeFrame[i].daysInMilk;
				}

				var conceptionRateData = _.map(cohortsWithinTimeFrame, function eachCohort(cohort) {
					return _.round((parseFloat(cohort.conceptionRate) / 100), 3);
				});

				var pregnancyRateData = _.map(cohortsWithinTimeFrame, function eachCohort(cohort) {
					return _.round((parseFloat(cohort.pregnancyRate) / 100), 3);
				});

				var labels = _.map(cohortsWithinTimeFrame, function eachCohort(cohort) {
					return cohort.breedingWeek;
				});

				chart = new Chart(jqChartElement, {
					type: 'bar',
					data: {
						labels: labels,
						datasets: [{
							data: conceptionRateData,
							backgroundColor: '#999'
						},{
							data: pregnancyRateData,
							backgroundColor: _.find(MSF.colorComponents, {color: 'blue'}).fillColor
						}]
					},
					options: {
						maintainAspectRatio: false,
						legend: {
							display: false
						},
						scales: {
							yAxes: [{
								ticks: {
									beginAtZero: true,
									callback: function addUnitsToLabel(value) {
										return _.round(value * 100) + '%';
									},
									stepSize: 0.20,
									max: 1
								}
							}],
							xAxes: [{
								categoryPercentage: 0.75,
								barPercentage: 0.9,
								gridLines: {
									display: false
								}
							}]
						},
						tooltips: {
							titleFontSize: 0,
							titleSpace: 0,
							titleMarginBottom: 0,
							bodyFontSize: 14,
							callbacks: {
								label: function formatLabel(item, chart) {
									return '';
								},
								afterBody: function afterBody(item, chart) {
									var lines = [];

									if (_.isArray(item) && item.length > 0) {
										var thisItem = item[0];
										var data1 = chart.datasets[0].data[thisItem.index];
										var data2 = chart.datasets[1].data[thisItem.index];
										lines = ['Cohort: ' + (thisItem.xLabel ? thisItem.xLabel : ''), 'DIM: ' + getDaysInMilk(thisItem.index)];

										if (thisItem.datasetIndex === 0) {
											lines.push('Conception Rate: ' + (_.round(thisItem.yLabel * 100, 1) + '%'));
										} else {
											lines.push('Pregnancy Rate: ' + (_.round(thisItem.yLabel * 100, 1) + '%'));
										}
									}

									return lines;
								}
							}
						}
					}
				});
			}

			function loadHerdFertilityPrograms() {
				self.loading = true;
				self.noDataOrErroneousData = false;
				self.fertilityProgramsToDisplay = [];
				self.incompleteSetupMessage = '';

				var herdId = MSF.getActiveHerd().herdId;

				async.auto({
					getCohorts: function getCohorts(done) {
						api.getHerdCohortsByHerdId(herdId, function gotHerdCohortsByHerdId(err, data) {
							if (err) {
								log.error({error: err}, 'Error getting cohort data');
							}

							return done(err, data);
						});
					},
					getPrograms: function getPrograms(done) {
						api.getHerdFertilityProgramsByHerdId(herdId, function programsGotten(err, data) {
							if (err) {
								log.error({error: err}, 'Error getting ferility programs by herdId');
							}

							return done(err, data);
						});
					}
				}, function gotCohortAndProgramData(err, results) {
					$s.$evalAsync(function gotCohortAndProgramDataWithApply() { // use $scope.$evalAsync here because $http callbacks have already been executed above so we need a digest for this code.
						self.loading = false;
						//#region evalAsync
						if (err) {
							self.fertilityProgramsToDisplay = [];
							var errorData = results.getCohorts || results.getPrograms;
							if (errorData.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
								self.incompleteSetupMessage = errorData.statusText;
							}

							return;
						}

						//#region setting latest date
						var cohortMinDate =
							_(results.getCohorts)
							.reject({breedingWeek: 'RHA'})
							.map('startDate')
							.min(function minDate(startDate) {
								return new Date(startDate).getTime();
							});

						if (cohortMinDate == -Infinity) {
							cohortMinDate = moment().minus(1, 'Y').format();
						}

						var cohortMaxDate =
							_(results.getCohorts)
							.reject({breedingWeek: 'RHA'})
							.map('startDate')
							.max(function maxDate(startDate) {
								return new Date(startDate).getTime();
							});

						if (cohortMinDate == Infinity) {
							cohortMinDate = '9999-12-31';
						}

						if (results.getPrograms.length === 0) {
							results.getPrograms = [{
								programStartDate: cohortMinDate,
								programEndDate: cohortMaxDate,
								gapFiller: true
							}];
						}
						//#endregion setting latest date

						// strip out the RHA values that have been shimmed into the cohorts result
						var rhaValues = _.find(results.getCohorts, {breedingWeek: 'RHA'});
						results.getCohorts = _.without(results.getCohorts, rhaValues);

						var today = moment().startOf('week').add(1, 'day').subtract(moment().utcOffset(), 'minutes');

						var cohortDataFormatted = _.map(results.getCohorts, function formatCohortData(cohort) {
							cohort.inseminationRateRaw = cohort.inseminationRate;
							cohort.conceptionRateRaw = cohort.conceptionRate;
							cohort.pregnancyRateRaw = cohort.pregnancyRate;
							cohort.breedingWeekRaw = cohort.breedingWeek;
							cohort.inseminationsPerPregnancyRaw = cohort.inseminationsPerPregnancy;
							cohort.herdId = herdId;
							cohort.inseminationRate = formattedRate(cohort.inseminationRate);
							cohort.conceptionRate = formattedRate(cohort.conceptionRate);
							cohort.pregnancyRate = formattedRate(cohort.pregnancyRate);
							cohort.inseminationsPerPregnancy = formattedDecimal(cohort.inseminationsPerPregnancy);
							cohort.startDate = new Date(moment(cohort.startDate).subtract(moment(cohort.startDate).utcOffset(), 'minutes').format());
							cohort.endDate = new Date(moment(cohort.endDate).subtract(moment(cohort.endDate).utcOffset(), 'minutes').format());
							cohort.clickable =
								(cohort.inseminationRate !== 'VWP' && cohort.inseminationRate !== 'N/A') ||
								(cohort.conceptionRate !== 'VWP' && cohort.conceptionRate !== 'N/A') ||
								(cohort.pregnancyRate !== 'VWP' && cohort.pregnancyRate !== 'N/A');
							cohort.daysInMilk =
								Math.floor(moment.duration(today.diff(moment(cohort.endDate))).as('days')) + ' - ' +
								Math.floor(moment.duration(today.diff(moment(cohort.startDate))).as('days'));

							return cohort;
						});

						var programDataFormatted		= _.map(results.getPrograms, function formatProgramData(program) {
							program.programStartDate	= new Date(moment(program.programStartDate).subtract(moment(program.programStartDate).utcOffset(), 'minutes').format());
							program.programEndDate		= new Date(moment(program.programEndDate).subtract(moment(program.programEndDate).utcOffset(), 'minutes').format());

							return program;
						});

						// sort cohorts and programs by end date
						cohorts = _.sortByOrder(cohortDataFormatted, function eachCohort(cohort) {
							return +moment(cohort.endDate);
						}, ['desc']);

						function sortPrograms(programs) {
							return _.sortByOrder(programs, function eachProgram(program) {
								return +moment(program.programEndDate);
							}, ['desc']);
						}

						var fertilityPrograms = sortPrograms(programDataFormatted);
						var twoWeekCohorts = fertilityPrograms[0].fertilityProgramFrequencyTypeId === 2;

						if (twoWeekCohorts) {
							cohorts = _.map(cohorts, function eachCohort(cohort) {
								cohort.breedingWeek = cohort.breedingWeek + '-' + (cohort.breedingWeek + 1);

								return cohort;
							});
						}

						// loop through programs to find any gaps between them and fill them with an "empty" program
						_.forEachRight(fertilityPrograms, function eachProgram(program, index) {
							if (index === 0) {
								return;
							}

							var prevProgram = program;
							var nextProgram = fertilityPrograms[index - 1];

							if (moment(nextProgram.programStartDate).diff(moment(prevProgram.programEndDate), 'days') > 1) {
								fertilityPrograms.push({
									programStartDate: new Date(moment(prevProgram.programEndDate).add(1, 'days')),
									programEndDate: new Date(moment(nextProgram.programStartDate).subtract(1, 'days')),
									gapFiller: true
								});
							}
						});

						// sort programs again after adding filler programs and filtering out old programs
						fertilityPrograms = sortPrograms(fertilityPrograms);

						// filter programs that have an end date greater than 1 year ago and have plans for both lactations (Parity type 2 and 3)
						self.fertilityProgramsToDisplay = _.filter(fertilityPrograms, function eachProgram(program) {
							
							var withinTheLastYear = moment().subtract(1, 'year').isBefore(program.programEndDate);

							return withinTheLastYear; // && lactationsHaveProtocols;
						});

						//#endregion evalAsync

						// cycle through each program and add the cohort data related to that program
						_.forEach(self.fertilityProgramsToDisplay, function eachProgramToDisplay(program) {
							program.cohortsToDisplay = _.filter(cohorts, function eachCohortToDisplay(cohort) {
								return +moment(cohort.startDate).startOf('day') >= +moment(program.programStartDate).startOf('day') &&
									+moment(cohort.endDate).startOf('day') <= +moment(program.programEndDate).startOf('day') &&
									moment(cohort.endDate).isBefore(moment());
							});
						});

						if (cohorts[0]) {
							var dt = _(cohorts).map('reportDate').max(function maxReportDate(i) {
								return new Date(i).getTime();
							});
						}

						updateChart();
						updateRhaBoxItems(rhaValues);

						var noData = self.fertilityProgramsToDisplay.length > 0 && !_.any(self.fertilityProgramsToDisplay, function hasCohortRows(program) {
							return program.cohortsToDisplay.length > 0;
						});

						var erroneousData = self.fertilityProgramsToDisplay.length > 0 && _.all(self.fertilityProgramsToDisplay, function hasInvalidData(program) {
							return program.cohortsToDisplay.length > 0 && _.all(program.cohortsToDisplay, function hasAllZeroRows(cohort) {
								return cohort.count === 0;
							});
						});

						if (noData) {
							log.info('There is no cohort fertility data to display');
						}

						if (erroneousData) {
							log.warn('The cohort fertility data contains potentially invalid data');
						}

						$s.noDataOrErroneousData = noData || erroneousData;
					});
				});
			}

			self.endDateToDisplay = function endDateToDisplay(programEndDate) {
				var formattedEndDate = moment(programEndDate).format('M/D/YYYY');

				return moment('9999-12-31').isSame(moment(programEndDate)) ? 'Current' : formattedEndDate;
			};

			self.chartRates = [{
				display: 'Insemination Rate',
				value: 'inseminationRate'
			}, {
				display: 'Conception Rate',
				value: 'conceptionRate'
			}, {
				display: 'Pregnancy Rate',
				value: 'pregnancyRate'
			}];

			self.chartTimeFrames = [{
				display: '3M',
				value: 3
			}, {
				display: '6M',
				value: 6
			}, {
				display: '1Y',
				value: 12
			}];

			self.chartState = {
				timeFrame: 12,
				rate: 'inseminationRate'
			};

			self.changeTimeFrame = function changeTimeFrame(timeFrame) {
				if (timeFrame === self.chartState.timeFrame) {
					return;
				}

				self.chartState.timeFrame = timeFrame;
				updateChart();
			};

			self.changeRate = function changeRate(rate) {
				if (rate === self.chartState.rate) {
					return;
				}

				self.chartState.rate = rate;
				updateChart();
			};

			self.viewFertilityProgram = function viewFertilityProgram(programId) {
				MSF.loadPage('FertilityCodes', {program: programId});
			};

			$s.$on('herd:changed', function herdChanged() {
				$s.checkPermissions();
			
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
				loadHerdFertilityPrograms();
			});

			MSF.ready(function onMsfReady() {
				$s.checkPermissions();
				
				var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
				var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
                var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
				loadHerdFertilityPrograms();
			});


			// Code supporting the display of reasons for 403 when viewing dashboard
			self.incompleteSetupMessage = '';
			self.setupIsIncomplete = function setupIsIncomplete() {
				return self.incompleteSetupMessage !== '';
			};
			self.getIncompleteSetupMessages = function getIncompleteSetupMessages() {
				return self.incompleteSetupMessage.split('|');
			};
			self.getTerritoryManager = function getTerritoryManager() {
				return MSF.getActiveFarmTerritoryManager();
			};
			// Add these to the scope so they are visible to the mixin
			$s.setupIsIncomplete = self.setupIsIncomplete;
			$s.getIncompleteSetupMessages = self.getIncompleteSetupMessages;
			$s.getTerritoryManager = self.getTerritoryManager;
		}
	]);
})();
